import React from "react";

function HometabIcons({ type, size = 24, color }) {
  const icons = {
    dashboard: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={color}
      >
        <g clipPath="url(#clip0_1657_101701)">
          <path
            d="M17.875 5.5H2.125C1.50475 5.5 1 4.99525 1 4.375V2.125C1 1.50475 1.50475 1 2.125 1H17.875C18.4953 1 19 1.50475 19 2.125V4.375C19 4.99525 18.4953 5.5 17.875 5.5ZM2.125 1.75C2.02554 1.75 1.93016 1.78951 1.85983 1.85983C1.78951 1.93016 1.75 2.02554 1.75 2.125V4.375C1.75 4.47446 1.78951 4.56984 1.85983 4.64016C1.93016 4.71049 2.02554 4.75 2.125 4.75H17.875C17.9745 4.75 18.0698 4.71049 18.1402 4.64016C18.2105 4.56984 18.25 4.47446 18.25 4.375V2.125C18.25 2.02554 18.2105 1.93016 18.1402 1.85983C18.0698 1.78951 17.9745 1.75 17.875 1.75H2.125ZM8.125 19H2.125C1.50475 19 1 18.4953 1 17.875V8.125C1 7.50475 1.50475 7 2.125 7H8.125C8.74525 7 9.25 7.50475 9.25 8.125V17.875C9.25 18.4953 8.74525 19 8.125 19ZM2.125 7.75C2.02554 7.75 1.93016 7.78951 1.85983 7.85983C1.78951 7.93016 1.75 8.02554 1.75 8.125V17.875C1.75 17.9745 1.78951 18.0698 1.85983 18.1402C1.93016 18.2105 2.02554 18.25 2.125 18.25H8.125C8.22446 18.25 8.31984 18.2105 8.39017 18.1402C8.46049 18.0698 8.5 17.9745 8.5 17.875V8.125C8.5 8.02554 8.46049 7.93016 8.39017 7.85983C8.31984 7.78951 8.22446 7.75 8.125 7.75H2.125ZM17.875 12.25H11.875C11.2548 12.25 10.75 11.7452 10.75 11.125V8.125C10.75 7.50475 11.2548 7 11.875 7H17.875C18.4953 7 19 7.50475 19 8.125V11.125C19 11.7452 18.4953 12.25 17.875 12.25ZM11.875 7.75C11.7755 7.75 11.6802 7.78951 11.6098 7.85983C11.5395 7.93016 11.5 8.02554 11.5 8.125V11.125C11.5 11.2245 11.5395 11.3198 11.6098 11.3902C11.6802 11.4605 11.7755 11.5 11.875 11.5H17.875C17.9745 11.5 18.0698 11.4605 18.1402 11.3902C18.2105 11.3198 18.25 11.2245 18.25 11.125V8.125C18.25 8.02554 18.2105 7.93016 18.1402 7.85983C18.0698 7.78951 17.9745 7.75 17.875 7.75H11.875ZM17.875 19H11.875C11.2548 19 10.75 18.4953 10.75 17.875V14.875C10.75 14.2548 11.2548 13.75 11.875 13.75H17.875C18.4953 13.75 19 14.2548 19 14.875V17.875C19 18.4953 18.4953 19 17.875 19ZM11.875 14.5C11.7755 14.5 11.6802 14.5395 11.6098 14.6098C11.5395 14.6802 11.5 14.7755 11.5 14.875V17.875C11.5 17.9745 11.5395 18.0698 11.6098 18.1402C11.6802 18.2105 11.7755 18.25 11.875 18.25H17.875C17.9745 18.25 18.0698 18.2105 18.1402 18.1402C18.2105 18.0698 18.25 17.9745 18.25 17.875V14.875C18.25 14.7755 18.2105 14.6802 18.1402 14.6098C18.0698 14.5395 17.9745 14.5 17.875 14.5H11.875Z"
            fill={color}
            stroke={color}
            strokeWidth="0.2"
          />
        </g>
        <defs>
          <clipPath id="clip0_1657_101701">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    secureObject: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={color}
      >
        <path
          d="M18.8055 4.63941L15.0366 3.22701L15.0345 3.22611L11.814 2.01921C11.7459 1.99349 11.6706 1.9936 11.6025 2.01951L4.61614 4.66551C4.59137 4.67415 4.56786 4.68605 4.54624 4.70091C4.54264 4.70331 4.53994 4.70691 4.53634 4.70961C4.53124 4.71351 4.52704 4.71801 4.52224 4.72221C4.48413 4.75519 4.45502 4.79731 4.43764 4.84461C4.43524 4.85151 4.43194 4.85781 4.43014 4.86471C4.42191 4.89155 4.41757 4.91944 4.41724 4.94751V8.60751C4.41724 8.68707 4.44884 8.76338 4.5051 8.81964C4.56136 8.8759 4.63767 8.90751 4.71724 8.90751C4.7968 8.90751 4.87311 8.8759 4.92937 8.81964C4.98563 8.76338 5.01724 8.68707 5.01724 8.60751V5.38101L7.91524 6.46701V8.36661C7.91524 8.44617 7.94684 8.52248 8.0031 8.57874C8.05937 8.635 8.13567 8.66661 8.21524 8.66661C8.2948 8.66661 8.37111 8.635 8.42737 8.57874C8.48363 8.52248 8.51524 8.44617 8.51524 8.36661V6.69201L11.4072 7.77561V15.5576L8.80084 14.579C8.76707 14.5663 8.7313 14.5598 8.69524 14.5598H8.69224C8.65292 14.5598 8.614 14.5676 8.5777 14.5828C8.54141 14.5979 8.50845 14.62 8.48072 14.6479C8.45299 14.6757 8.43103 14.7088 8.41611 14.7452C8.40118 14.7815 8.39358 14.8205 8.39374 14.8598C8.39374 14.9915 8.47954 15.1034 8.59804 15.1439L11.6016 16.2716C11.6055 16.2731 11.6097 16.2725 11.6136 16.2737C11.645 16.2852 11.6781 16.2912 11.7114 16.2917C11.7294 16.2917 11.7471 16.2854 11.7651 16.2821C11.7765 16.2797 11.7879 16.2794 11.7987 16.2761C11.8047 16.2743 11.811 16.2749 11.8167 16.2728L18.8052 13.6529C18.8625 13.6315 18.9118 13.593 18.9466 13.5428C18.9813 13.4926 19 13.4329 18.9999 13.3718V4.94781C18.9999 4.94241 18.9984 4.93761 18.9981 4.93221C18.9981 4.92801 18.9999 4.92411 18.9999 4.91991C18.9999 4.8589 18.9812 4.79937 18.9464 4.74926C18.9116 4.69914 18.8624 4.66082 18.8052 4.63941H18.8055ZM11.7093 7.24671L9.03454 6.24441L14.9244 3.82581L17.8491 4.92171L11.7093 7.24671ZM11.7093 2.62101L14.0988 3.51651L8.20894 5.93511L5.56924 4.94601L11.7093 2.62101ZM18.4002 13.1633L12.0117 15.5582V7.77441L18.4002 5.38041V13.163V13.1633Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
        <path
          d="M2.5333 16.3855C3.1144 16.8715 3.8215 17.2366 4.6351 17.4709C4.68929 17.4866 4.74681 17.4866 4.801 17.4709C5.6137 17.2363 6.3202 16.8712 6.9013 16.3852C7.8754 15.5665 8.4337 14.3347 8.4337 13.0063V10.3756C8.43361 10.3332 8.42456 10.2914 8.40714 10.2527C8.38972 10.2141 8.36432 10.1796 8.33262 10.1514C8.30092 10.1233 8.26363 10.1022 8.22319 10.0895C8.18276 10.0768 8.14009 10.0728 8.098 10.0777C5.9602 10.3348 4.9147 9.53562 4.906 9.52872C4.85277 9.48631 4.78677 9.46311 4.71871 9.46289C4.65065 9.46267 4.5845 9.48545 4.531 9.52752C4.5205 9.53562 3.4708 10.3354 1.3357 10.0777C1.29359 10.0727 1.25089 10.0766 1.21041 10.0893C1.16993 10.1019 1.1326 10.1231 1.10088 10.1512C1.06915 10.1794 1.04376 10.2139 1.02637 10.2526C1.00898 10.2913 0.999996 10.3332 1 10.3756V13.0063C1 14.3347 1.5589 15.5662 2.5333 16.3855ZM1.6003 10.7068C3.2929 10.8382 4.3201 10.3615 4.7182 10.1227C5.116 10.3615 6.1426 10.8397 7.8343 10.7068V13.0063C7.8343 14.1571 7.3537 15.2212 6.5161 15.9253C6.0196 16.3408 5.4151 16.6582 4.7179 16.8697C4.0201 16.6585 3.415 16.3411 2.9188 15.9259C2.0809 15.2215 1.6 14.1571 1.6 13.0066L1.6003 10.7068Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
        <path
          d="M4.21979 14.3565C4.24759 14.3844 4.28064 14.4066 4.31704 14.4218C4.35344 14.4369 4.39247 14.4447 4.43189 14.4447C4.47131 14.4447 4.51035 14.4369 4.54675 14.4218C4.58315 14.4066 4.6162 14.3844 4.64399 14.3565L6.32339 12.6771C6.35125 12.6492 6.37334 12.6162 6.38841 12.5798C6.40349 12.5434 6.41125 12.5044 6.41125 12.465C6.41125 12.4256 6.40349 12.3866 6.38841 12.3502C6.37334 12.3138 6.35125 12.2807 6.32339 12.2529C6.29554 12.225 6.26247 12.2029 6.22608 12.1879C6.18969 12.1728 6.15068 12.165 6.11129 12.165C6.0719 12.165 6.0329 12.1728 5.9965 12.1879C5.96011 12.2029 5.92705 12.225 5.89919 12.2529L4.43189 13.7202L3.53549 12.8238C3.50764 12.7959 3.47457 12.7738 3.43818 12.7588C3.40179 12.7437 3.36278 12.7359 3.32339 12.7359C3.284 12.7359 3.245 12.7437 3.2086 12.7588C3.17221 12.7738 3.13915 12.7959 3.11129 12.8238C3.08344 12.8516 3.06134 12.8847 3.04627 12.9211C3.0312 12.9575 3.02344 12.9965 3.02344 13.0359C3.02344 13.0753 3.0312 13.1143 3.04627 13.1507C3.06134 13.1871 3.08344 13.2201 3.11129 13.248L4.21979 14.3565Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
      </svg>
    ),

    secureIAM: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none" // Ensure fill is "none" for the SVG element
      >
        <path
          d="M2 5.20117H17.8381"
          stroke={color} // Apply color to stroke
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none" // Ensure fill is "none" for paths
        />
        <path
          d="M14.1582 3.60059H14.1609"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M15.8955 3.60059H15.8982"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M12.4207 3.60059H12.4233"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M3.93994 3.60059H8.77708"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle
          cx="10"
          cy="12"
          r="5.1"
          stroke={color}
          strokeWidth="0.8"
          fill="none" // Ensure fill is "none" for circles
        />
        <path
          d="M5.46566 14.6006H2.71085C2.31937 14.6006 2 14.2981 2 13.9292V2.67133C2 2.30162 2.31937 1.99999 2.71085 1.99999H17.1273C17.5179 1.99999 17.8381 2.30162 17.8381 2.67133V13.9292C17.8381 14.2981 17.5179 14.6006 17.1273 14.6006H14.3725"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M9.9187 12.7509V13.4766"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M8.17676 11.2432H11.6607V10.1564C11.6607 9.42905 11.0301 8.83268 10.2591 8.83268H9.57834C8.80819 8.83268 8.17676 9.42905 8.17676 10.1564V11.2432Z"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M12.3549 12.9089C12.3549 14.174 11.259 15.21 9.91855 15.21C8.579 15.21 7.48218 14.174 7.48218 12.9089V11.7463C7.48218 11.4697 7.72216 11.243 8.01601 11.243H11.822C12.1149 11.243 12.3549 11.4697 12.3549 11.7463V12.9089Z"
          stroke={color}
          strokeWidth="0.8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    ),
    ysafe: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_1635_101663)">
          <path
            d="M13.7194 17.8294H1.7317C1.3293 17.8294 1 17.5001 1 17.0977V6.48796C1 6.28674 1.16463 6.12211 1.36582 6.12211H6.27284C6.55177 6.12211 6.7827 6.31059 6.88012 6.55421L7.58538 8.31726H15.6341C16.0365 8.31726 16.3658 8.64652 16.3658 9.04892V10.82M2.82927 5.75626V1.36585C2.82927 1.16463 2.9939 1 3.19512 1H14.1707C14.3719 1 14.5365 1.16463 14.5365 1.36585V7.95137M4.53048 2.46358H12.8353M4.53048 3.92699H12.8353M8.68292 5.3904H12.8353M10.6768 6.85381H12.8353M15.3414 19.0001C20.0106 16.3347 18.8795 11.5791 18.8795 11.5791C17.9812 11.5791 16.0105 10.8813 15.3414 10.2197C14.6723 10.8813 12.7017 11.5791 11.8034 11.5791C11.8034 11.5791 10.6723 16.3347 15.3414 19.0001ZM13.4573 15.0724C13.1716 14.7867 13.1716 14.3234 13.4573 14.0377C13.7431 13.752 14.2063 13.752 14.492 14.0377L14.9223 14.468L16.1907 13.1996C16.4765 12.9138 16.9397 12.9138 17.2254 13.1996C17.5111 13.4853 17.5111 13.9485 17.2254 14.2342L15.4396 16.02C15.154 16.3057 14.6907 16.3057 14.405 16.02L13.4573 15.0724Z"
            stroke={color}
            strokeWidth="0.8"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </g>
        <defs>
          <clipPath id="clip0_1635_101663">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    passwordManager: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={color}
      >
        <path
          d="M9.75266 1C7.64369 1 5.92772 2.71597 5.92772 4.82494V6.46591H4.87174C4.79217 6.46591 4.71587 6.49752 4.65961 6.55378C4.60335 6.61004 4.57174 6.68634 4.57174 6.7659V13.2038H2.27498C1.93696 13.2042 1.61289 13.3386 1.37387 13.5777C1.13485 13.8167 1.0004 14.1408 1 14.4788V17.725C1.0004 18.063 1.13485 18.3871 1.37387 18.6261C1.61289 18.8651 1.93696 18.9996 2.27498 19H17.2303C17.5684 18.9996 17.8924 18.8651 18.1314 18.6261C18.3705 18.3871 18.5049 18.063 18.5053 17.725V14.4788C18.5049 14.1408 18.3705 13.8167 18.1314 13.5777C17.8924 13.3386 17.5684 13.2042 17.2303 13.2038H14.9336V6.7659C14.9336 6.68634 14.902 6.61004 14.8457 6.55378C14.7894 6.49752 14.7131 6.46591 14.6336 6.46591H13.5776V4.82494C13.5776 2.71597 11.8616 1 9.75266 1ZM6.52771 4.82494C6.52771 3.04657 7.97428 1.59999 9.75266 1.59999C11.531 1.59999 12.9776 3.04657 12.9776 4.82494V6.46591H12.1706V4.82494C12.1706 3.49176 11.0858 2.40698 9.75266 2.40698C8.41948 2.40698 7.3347 3.49176 7.3347 4.82494V6.46591H6.52771V4.82494ZM7.93469 6.46591V4.82494C7.93469 3.82265 8.75037 3.00697 9.75266 3.00697C10.7549 3.00697 11.5706 3.82265 11.5706 4.82494V6.46591H7.93469ZM17.905 14.4788V17.725C17.905 18.097 17.6023 18.4 17.23 18.4H2.27498C2.09603 18.3998 1.92449 18.3286 1.79795 18.202C1.67142 18.0755 1.60023 17.904 1.59999 17.725V14.4788C1.59999 14.1068 1.90269 13.8038 2.27498 13.8038H17.2303C17.6023 13.8038 17.905 14.1065 17.905 14.4788ZM14.3336 13.2038H5.17173V7.0659H14.3336V13.2038Z"
          fill={color}
          stroke={color}
          strokeWidth="0.1"
        />
        <path
          d="M5.77842 15.4186C5.75827 15.3847 5.73165 15.3552 5.70008 15.3316C5.6685 15.308 5.63259 15.2909 5.5944 15.2812C5.55621 15.2715 5.51648 15.2694 5.47748 15.2751C5.43848 15.2807 5.40099 15.294 5.36713 15.3142L4.93003 15.574V15.0655C4.93003 14.9859 4.89843 14.9096 4.84217 14.8534C4.78591 14.7971 4.7096 14.7655 4.63004 14.7655C4.55048 14.7655 4.47417 14.7971 4.41791 14.8534C4.36165 14.9096 4.33004 14.9859 4.33004 15.0655V15.574L3.89295 15.3139C3.85909 15.2937 3.82159 15.2805 3.7826 15.2748C3.7436 15.2691 3.70388 15.2712 3.66568 15.2809C3.62749 15.2906 3.59158 15.3077 3.56001 15.3313C3.52843 15.3549 3.50181 15.3844 3.48166 15.4183C3.46151 15.4521 3.44822 15.4896 3.44256 15.5286C3.4369 15.5676 3.43898 15.6074 3.44868 15.6456C3.45837 15.6837 3.47549 15.7197 3.49906 15.7512C3.52264 15.7828 3.5522 15.8094 3.58606 15.8296L4.04295 16.1014L3.58606 16.3732C3.51867 16.4143 3.47023 16.4804 3.45122 16.557C3.43221 16.6336 3.44418 16.7147 3.48453 16.7825C3.52487 16.8504 3.59035 16.8996 3.66675 16.9195C3.74315 16.9394 3.82432 16.9284 3.89265 16.8889L4.32974 16.6288V17.1373C4.32974 17.2168 4.36135 17.2931 4.41761 17.3494C4.47387 17.4056 4.55018 17.4373 4.62974 17.4373C4.7093 17.4373 4.78561 17.4056 4.84187 17.3494C4.89813 17.2931 4.92973 17.2168 4.92973 17.1373V16.6288L5.36683 16.8886C5.40064 16.9088 5.43812 16.9221 5.47711 16.9278C5.5161 16.9335 5.55583 16.9315 5.59402 16.9218C5.63221 16.9121 5.66811 16.8949 5.69965 16.8713C5.7312 16.8477 5.75776 16.8181 5.77782 16.7842C5.81845 16.7158 5.83028 16.634 5.8107 16.5569C5.79113 16.4798 5.74176 16.4136 5.67342 16.3729L5.21653 16.1011L5.67342 15.8293C5.70729 15.8091 5.73685 15.7825 5.76043 15.7509C5.78401 15.7194 5.80113 15.6835 5.81082 15.6453C5.82052 15.6071 5.82259 15.5673 5.81693 15.5283C5.81127 15.4893 5.79798 15.4518 5.77782 15.418L5.77842 15.4186ZM9.19356 15.4186C9.17342 15.3847 9.1468 15.3552 9.11522 15.3316C9.08365 15.308 9.04774 15.2909 9.00954 15.2812C8.97135 15.2715 8.93162 15.2694 8.89262 15.2751C8.85363 15.2807 8.81613 15.294 8.78227 15.3142L8.34518 15.574V15.0655C8.34518 14.9859 8.31357 14.9096 8.25731 14.8534C8.20105 14.7971 8.12475 14.7655 8.04518 14.7655C7.96562 14.7655 7.88931 14.7971 7.83305 14.8534C7.77679 14.9096 7.74519 14.9859 7.74519 15.0655V15.574L7.30809 15.3139C7.27423 15.2937 7.23674 15.2805 7.19774 15.2748C7.15875 15.2691 7.11902 15.2712 7.08083 15.2809C7.04263 15.2906 7.00673 15.3077 6.97515 15.3313C6.94358 15.3549 6.91695 15.3844 6.8968 15.4183C6.87665 15.4521 6.86337 15.4896 6.85771 15.5286C6.85205 15.5676 6.85412 15.6074 6.86382 15.6456C6.87351 15.6837 6.89064 15.7197 6.91421 15.7512C6.93778 15.7828 6.96734 15.8094 7.0012 15.8296L7.45809 16.1014L7.0012 16.3732C6.93382 16.4143 6.88537 16.4804 6.86636 16.557C6.84736 16.6336 6.85932 16.7147 6.89967 16.7825C6.94002 16.8504 7.00549 16.8996 7.08189 16.9195C7.15829 16.9394 7.23946 16.9284 7.30779 16.8889L7.74489 16.6288V17.1373C7.74489 17.2168 7.77649 17.2931 7.83275 17.3494C7.88901 17.4056 7.96532 17.4373 8.04488 17.4373C8.12445 17.4373 8.20075 17.4056 8.25701 17.3494C8.31327 17.2931 8.34488 17.2168 8.34488 17.1373V16.6288L8.78197 16.8886C8.81578 16.9088 8.85326 16.9221 8.89225 16.9278C8.93124 16.9335 8.97097 16.9315 9.00917 16.9218C9.04736 16.9121 9.08325 16.8949 9.1148 16.8713C9.14634 16.8477 9.1729 16.8181 9.19296 16.7842C9.23359 16.7158 9.24542 16.634 9.22585 16.5569C9.20627 16.4798 9.1569 16.4136 9.08856 16.3729L8.63167 16.1011L9.08856 15.8293C9.12243 15.8091 9.152 15.7825 9.17557 15.7509C9.19915 15.7194 9.21627 15.6835 9.22597 15.6453C9.23566 15.6071 9.23774 15.5673 9.23208 15.5283C9.22641 15.4893 9.21312 15.4518 9.19296 15.418L9.19356 15.4186ZM12.6084 15.4186C12.5883 15.3847 12.5616 15.3552 12.5301 15.3316C12.4985 15.308 12.4626 15.2909 12.4244 15.2812C12.3862 15.2715 12.3465 15.2694 12.3075 15.2751C12.2685 15.2807 12.231 15.294 12.1971 15.3142L11.76 15.5743V15.0658C11.76 14.9862 11.7284 14.9099 11.6722 14.8537C11.6159 14.7974 11.5396 14.7658 11.46 14.7658C11.3805 14.7658 11.3042 14.7974 11.2479 14.8537C11.1916 14.9099 11.16 14.9862 11.16 15.0658V15.5743L10.7229 15.3145C10.6891 15.2943 10.6516 15.2811 10.6126 15.2754C10.5736 15.2697 10.5339 15.2718 10.4957 15.2815C10.4575 15.2912 10.4216 15.3083 10.39 15.3319C10.3584 15.3555 10.3318 15.385 10.3116 15.4189C10.2915 15.4527 10.2782 15.4902 10.2726 15.5292C10.2669 15.5682 10.269 15.608 10.2787 15.6462C10.2884 15.6843 10.3055 15.7203 10.3291 15.7518C10.3526 15.7834 10.3822 15.81 10.416 15.8302L10.8729 16.102L10.416 16.3738C10.3487 16.4149 10.3002 16.481 10.2812 16.5576C10.2622 16.6342 10.2742 16.7153 10.3145 16.7831C10.3549 16.851 10.4203 16.9002 10.4967 16.9201C10.5731 16.94 10.6543 16.929 10.7226 16.8895L11.1597 16.6297V17.1382C11.1597 17.2177 11.1913 17.294 11.2476 17.3503C11.3039 17.4065 11.3802 17.4382 11.4597 17.4382C11.5393 17.4382 11.6156 17.4065 11.6719 17.3503C11.7281 17.294 11.7597 17.2177 11.7597 17.1382V16.6297L12.1968 16.8898C12.2306 16.91 12.2681 16.9233 12.3071 16.929C12.3461 16.9347 12.3858 16.9327 12.424 16.923C12.4622 16.9133 12.4981 16.8961 12.5296 16.8725C12.5612 16.8489 12.5877 16.8193 12.6078 16.7854C12.6484 16.717 12.6603 16.6352 12.6407 16.5581C12.6211 16.481 12.5717 16.4148 12.5034 16.3741L12.0465 16.1023L12.5034 15.8305C12.5373 15.8103 12.5668 15.7837 12.5904 15.7521C12.614 15.7206 12.6311 15.6847 12.6408 15.6465C12.6505 15.6083 12.6526 15.5685 12.6469 15.5295C12.6413 15.4905 12.628 15.453 12.6078 15.4192L12.6084 15.4186ZM14.5752 15.574L14.1381 15.3142C14.0697 15.2735 13.9879 15.2616 13.9108 15.2812C13.8337 15.3008 13.7675 15.3502 13.7268 15.4186C13.6861 15.487 13.6742 15.5687 13.6938 15.6459C13.7134 15.723 13.7628 15.7892 13.8312 15.8299L14.2881 16.1017L13.8312 16.3735C13.7638 16.4146 13.7154 16.4807 13.6963 16.5573C13.6773 16.6339 13.6893 16.715 13.7297 16.7828C13.77 16.8507 13.8355 16.8999 13.9119 16.9198C13.9883 16.9397 14.0694 16.9287 14.1378 16.8892L14.5749 16.6294V17.1379C14.5749 17.2174 14.6065 17.2937 14.6627 17.35C14.719 17.4062 14.7953 17.4379 14.8749 17.4379C14.9544 17.4379 15.0307 17.4062 15.087 17.35C15.1433 17.2937 15.1749 17.2174 15.1749 17.1379V16.6294L15.612 16.8895C15.6458 16.9097 15.6832 16.923 15.7222 16.9287C15.7612 16.9344 15.801 16.9324 15.8392 16.9227C15.8773 16.913 15.9132 16.8958 15.9448 16.8722C15.9763 16.8486 16.0029 16.819 16.0229 16.7851C16.0636 16.7167 16.0754 16.6349 16.0558 16.5578C16.0363 16.4807 15.9869 16.4145 15.9186 16.3738L15.4617 16.102L15.9186 15.8302C15.9524 15.81 15.982 15.7834 16.0055 15.7518C16.0291 15.7203 16.0462 15.6843 16.0559 15.6462C16.0656 15.608 16.0677 15.5682 16.062 15.5292C16.0564 15.4902 16.0431 15.4527 16.0229 15.4189C16.0028 15.385 15.9762 15.3555 15.9446 15.3319C15.913 15.3083 15.8771 15.2912 15.8389 15.2815C15.8007 15.2718 15.761 15.2697 15.722 15.2754C15.683 15.2811 15.6455 15.2943 15.6117 15.3145L15.1746 15.5746V15.0661C15.1746 14.9865 15.143 14.9102 15.0867 14.854C15.0304 14.7977 14.9541 14.7661 14.8746 14.7661C14.795 14.7661 14.7187 14.7977 14.6624 14.854C14.6062 14.9102 14.5746 14.9865 14.5746 15.0661V15.5746L14.5752 15.574ZM9.75275 8.5166C9.44433 8.517 9.14865 8.6397 8.93056 8.85779C8.71247 9.07588 8.58977 9.37156 8.58937 9.67998C8.58937 10.217 8.95717 10.6658 9.45276 10.7993V11.5889C9.45276 11.6684 9.48437 11.7447 9.54063 11.801C9.59689 11.8572 9.67319 11.8888 9.75275 11.8888C9.83232 11.8888 9.90862 11.8572 9.96488 11.801C10.0211 11.7447 10.0527 11.6684 10.0527 11.5889V10.7993C10.5483 10.6661 10.9161 10.2173 10.9161 9.67998C10.9157 9.37156 10.793 9.07588 10.575 8.85779C10.3569 8.6397 10.0612 8.517 9.75275 8.5166ZM9.75275 10.2434C9.44196 10.2434 9.18936 9.99078 9.18936 9.67998C9.18936 9.36919 9.44196 9.11659 9.75275 9.11659C10.0635 9.11659 10.3161 9.36919 10.3161 9.67998C10.3161 9.99078 10.0635 10.2434 9.75275 10.2434Z"
          fill={color}
        />
      </svg>
    ),
    edit: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        id="edit"
      >
        <path
          d="M5.83301 5.83342H4.99967C4.55765 5.83342 4.13372 6.00902 3.82116 6.32158C3.5086 6.63414 3.33301 7.05806 3.33301 7.50009V15.0001C3.33301 15.4421 3.5086 15.866 3.82116 16.1786C4.13372 16.4912 4.55765 16.6668 4.99967 16.6668H12.4997C12.9417 16.6668 13.3656 16.4912 13.6782 16.1786C13.9907 15.866 14.1663 15.4421 14.1663 15.0001V14.1668M13.333 4.16676L15.833 6.66676M16.9872 5.48759C17.3154 5.15938 17.4998 4.71424 17.4998 4.25009C17.4998 3.78594 17.3154 3.34079 16.9872 3.01259C16.659 2.68438 16.2138 2.5 15.7497 2.5C15.2855 2.5 14.8404 2.68438 14.5122 3.01259L7.49967 10.0001V12.5001H9.99967L16.9872 5.48759Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    logout: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M14 8V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V16M9 12H21M21 12L18 9M21 12L18 15"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    rename: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2.66797 13.3342H5.33464L12.3346 6.33419C12.5097 6.15909 12.6486 5.95122 12.7434 5.72245C12.8381 5.49367 12.8869 5.24848 12.8869 5.00085C12.8869 4.75323 12.8381 4.50803 12.7434 4.27926C12.6486 4.05048 12.5097 3.84262 12.3346 3.66752C12.1595 3.49242 11.9517 3.35353 11.7229 3.25877C11.4941 3.16401 11.2489 3.11523 11.0013 3.11523C10.7537 3.11523 10.5085 3.16401 10.2797 3.25877C10.0509 3.35353 9.84306 3.49242 9.66797 3.66752L2.66797 10.6675V13.3342Z"
          stroke="url(#paint0_linear_2405_12268)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4.33398L11.6667 7.00065"
          stroke="url(#paint1_linear_2405_12268)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.668 12.666H14.668"
          stroke="url(#paint2_linear_2405_12268)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2405_12268"
            x1="2.00662"
            y1="11.6435"
            x2="13.9151"
            y2="11.8628"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2405_12268"
            x1="8.82742"
            y1="6.55945"
            x2="11.935"
            y2="6.61669"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2405_12268"
            x1="10.4091"
            y1="13.5006"
            x2="15.0468"
            y2="13.8423"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    share: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2405_12274)">
          <path
            d="M2 8C2 8.53043 2.21071 9.03914 2.58579 9.41421C2.96086 9.78929 3.46957 10 4 10C4.53043 10 5.03914 9.78929 5.41421 9.41421C5.78929 9.03914 6 8.53043 6 8C6 7.46957 5.78929 6.96086 5.41421 6.58579C5.03914 6.21071 4.53043 6 4 6C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8Z"
            stroke="url(#paint0_linear_2405_12274)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4C10 4.53043 10.2107 5.03914 10.5858 5.41421C10.9609 5.78929 11.4696 6 12 6C12.5304 6 13.0391 5.78929 13.4142 5.41421C13.7893 5.03914 14 4.53043 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4Z"
            stroke="url(#paint1_linear_2405_12274)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12Z"
            stroke="url(#paint2_linear_2405_12274)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.80078 7.13385L10.2008 4.86719"
            stroke="url(#paint3_linear_2405_12274)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.80078 8.86719L10.2008 11.1339"
            stroke="url(#paint4_linear_2405_12274)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2405_12274"
            x1="1.74113"
            y1="9.3382"
            x2="6.40247"
            y2="9.42407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2405_12274"
            x1="9.74113"
            y1="5.3382"
            x2="14.4025"
            y2="5.42407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2405_12274"
            x1="9.74113"
            y1="13.3382"
            x2="14.4025"
            y2="13.4241"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2405_12274"
            x1="5.51602"
            y1="6.75884"
            x2="10.6387"
            y2="6.94201"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2405_12274"
            x1="5.51602"
            y1="10.7588"
            x2="10.6387"
            y2="10.942"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_2405_12274">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    ungroup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M9.33464 11.3327H13.3346M2.66797 2.66602H6.66797V6.66602H2.66797V2.66602ZM9.33464 2.66602H13.3346V6.66602H9.33464V2.66602ZM2.66797 9.33268H6.66797V13.3327H2.66797V9.33268Z"
          stroke="url(#paint0_linear_2405_12283)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2405_12283"
            x1="1.97764"
            y1="11.5679"
            x2="14.4079"
            y2="11.7969"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    )
  };

  return icons[type];
}

export default HometabIcons;
